/* ==================================================
   RECUPERATION DES DATES JUDGE.ME
================================================== */

function mpSyncJudgeMeDates() {

  const cards = document.querySelectorAll(
    '.jdgm-cards-carousel .jdgm-carousel-item[data-review-id]'
  );

  cards.forEach(function(card) {

    const reviewId = card.getAttribute('data-review-id');
    if (!reviewId) return;

    const reviewerInfo = card.querySelector('.jdgm-reviewer-info');
    if (!reviewerInfo) return;

    /* Supprime la coche noire */
    const verifiedIcon = reviewerInfo.querySelector(
      '.jdgm-reviewer-verified-icon'
    );

    if (verifiedIcon) {
      verifiedIcon.style.display = 'none';
    }

    /* Évite d'ajouter deux fois la date */
    if (reviewerInfo.querySelector('.mp-review-date')) return;

    /* Cherche le même avis dans l'ancien carrousel */
    const legacyReviews = document.querySelectorAll(
      '.jdgm-carousel-item[data-review-id="' + reviewId + '"]'
    );

    let timestamp = null;

    legacyReviews.forEach(function(review) {
      const found = review.querySelector(
        '.jdgm-carousel-item__timestamp'
      );

      if (found) {
        timestamp = found;
      }
    });

    if (!timestamp) return;

    const dateText = timestamp.textContent.trim();
    if (!dateText) return;

    const date = document.createElement('span');
    date.className = 'mp-review-date';
    date.textContent = dateText;

    reviewerInfo.appendChild(date);
  });
}


/* Judge.me peut charger les avis avec un petit délai */
let mpDateAttempts = 0;

const mpDateTimer = setInterval(function() {

  mpSyncJudgeMeDates();

  mpDateAttempts++;

  if (mpDateAttempts >= 40) {
    clearInterval(mpDateTimer);
  }

}, 500);


/* Éditeur Shopify */
document.addEventListener('shopify:section:load', function() {
  setTimeout(mpSyncJudgeMeDates, 500);
  setTimeout(mpSyncJudgeMeDates, 1500);
});

document.addEventListener('DOMContentLoaded', function () {

  function addVerifiedReviewsButton() {

    const panel = document.querySelector('.jdgm-cards-carousel');
    const allReviews = document.querySelector('.jm-reviews-grid-widget');

    if (!panel || !allReviews) return;

    if (panel.querySelector('.mp-judgeme-all-reviews')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'mp-judgeme-all-reviews';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mp-judgeme-all-reviews__button';
    button.innerHTML = '💜 Découvrir tous nos avis vérifiés';

    button.addEventListener('click', function () {
      allReviews.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });

    wrapper.appendChild(button);
    panel.appendChild(wrapper);
  }

  addVerifiedReviewsButton();

  const observer = new MutationObserver(function () {
    addVerifiedReviewsButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});